import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TestReviewPage.css";
import search from "../../../assets/search.png";

type TestQuestion = {
  number: number;
  id: number;
  text: string;
  answer1: string;
  answer2: string;
  answer3: string;
  answer4: string;
};

const getQuestionOptions = (question: TestQuestion) => [
  { number: 1, text: question.answer1 },
  { number: 2, text: question.answer2 },
  { number: 3, text: question.answer3 },
  { number: 4, text: question.answer4 },
];

const MOSCOW_TIME_ZONE = "Europe/Moscow";

const formatCourseDate = (value?: string | null) => {
  const date = value ? new Date(value) : new Date();
  return Number.isNaN(date.getTime())
    ? new Date().toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE })
    : date.toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE });
};

const formatMoscowDateTime = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString("ru-RU", { timeZone: MOSCOW_TIME_ZONE })
    : "";

const calculateElapsedTime = (start: string, end: string): string => {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const diffMs = endTime.getTime() - startTime.getTime();

  const hours = Math.floor(diffMs / 3600000);
  const minutes = Math.floor((diffMs % 3600000) / 60000);
  const seconds = Math.floor((diffMs % 60000) / 1000);

  return `${hours} ч ${minutes} мин ${seconds} сек`;
};

const TestReviewPage: React.FC = () => {
  const startTime = localStorage.getItem("startTime");
  const endTime = localStorage.getItem("endTime");
  const questions = JSON.parse(
    localStorage.getItem("testQuestions") || "[]"
  ) as TestQuestion[];

  const elapsedTime =
    startTime && endTime
      ? calculateElapsedTime(startTime, endTime)
      : "Неизвестно";

  const [currentQuestion, setCurrentQuestion] = useState<number>(() => {
    const savedQuestion = localStorage.getItem("currentQuestion");
    return savedQuestion ? parseInt(savedQuestion, 10) : 0;
  });

  const [answers] = useState<number[]>(() => {
    const savedAnswers = localStorage.getItem("answers");
    return savedAnswers ? JSON.parse(savedAnswers) : Array(questions.length).fill(0);
  });

  const questionRefs = useRef<HTMLDivElement[]>([]);
  const navigate = useNavigate();

  const handleScrollToQuestion = (index: number) => {
    questionRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    setCurrentQuestion(index);
    localStorage.setItem("currentQuestion", index.toString());
  };

  const handleSubmit = () => {
    navigate("/test-result", { state: { answers } });
  };

  return (
    <div className="test-page-container">
      <div className="title"></div>

      <div className="title22">
        <div>Тестирование - 1 -й этап</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="course-breadcrumb">
        Мои курсы › Тестирование - 1-й этап {formatCourseDate(startTime)}
      </div>
      <div
        onClick={() => {
          localStorage.clear();

          navigate("/");
        }}
        className="gohome"
      >
        Выход
      </div>
      <div className="report">
        <div>
          <b>Тест начат:</b>
          {startTime
            ? formatMoscowDateTime(startTime)
            : "Неизвестно"}
        </div>
        <div>
          <b>Состояние:</b> Завершен
        </div>
        <div>
          <b>Завершен: </b>
          {endTime ? formatMoscowDateTime(endTime) : "Неизвестно"}
        </div>
        <div>
          <b>Прошло времени:</b> {elapsedTime}
        </div>
      </div>
      <div className="test-content">
        <div className="questions">
          <div className="questions-container">
            {questions.map((question, index) => (
              <div
                key={question.id}
                ref={(el) => (questionRefs.current[index] = el!)}
                className="question-cont"
              >
                <div className="question-title">
                  <div>
                    Вопрос <b>{index + 1}</b>
                  </div>
                  <div>{answers[index] ? "Ответ дан" : "Нет ответа"}</div>
                  <div>Балл: 1,00</div>
                </div>
                <div className="question-item">
                  <div>{question.text}</div>
                  <div className="options-list">
                    {getQuestionOptions(question).map((option) => (
                      <label key={option.number}>
                        <input
                          type="radio"
                          name={`question-${index}`}
                          value={option.number}
                          checked={answers[index] === option.number}
                          readOnly
                          className="form_radio"
                        />
                        {option.number}. {option.text}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button className="finish-test2" onClick={handleSubmit}>
            Закончить обзор
          </button>
        </div>
        <div className="navigation-panel">
          <div className="nav-title">Навигация по тесту</div>
          {questions.map((_, index) => (
            <button
              key={index}
              className={`navigation-button ${answers[index] ? "answered" : ""}`}
              onClick={() => handleScrollToQuestion(index)}
            >
              {index + 1}
            </button>
          ))}
          <div className="finish-test" onClick={handleSubmit}>
            Закончить обзор
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestReviewPage;
